import { ChiptaElement, html, css } from 'chipta-libs/main.js';
import './font-awesome.js';


export default class ArrowLink extends ChiptaElement {

  render() {

    const href = this.getAttribute('href');

    if (href) {
      return html`<a id="arrow-link" href=${href}>${this.arrowAndText}</a>`;
    } else {
      return html`<span id="arrow-link">${this.arrowAndText}</span>`;
    }

  }

  get arrowAndText() {

    if (this.getAttribute('direction') === 'left') {
      return html`
        <font-awesome id="icon" icon="arrow-left" icon-style="custom"></font-awesome>
        <slot></slot>
      `;
    } else {
      return html`
        <slot></slot>
        <font-awesome id="icon" icon="arrow-right" icon-style="custom"></font-awesome>
      `;
    }

  }

  static get styles() {

    return css`

      :host {
        display: block;
      }

      #arrow-link {
        font-size: 16px;
        font-weight: bold;
        color: #00ADEE;
        text-decoration: none;
        cursor: pointer;
      }

    `;

  }

}

customElements.define('arrow-link', ArrowLink);
